import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getAllCashiers } from "../../../store/cashier/actions"
import {sitename} from "../../../constants/constants";
const Cashiers = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllCashiers())
  }, [dispatch])
  const Cashiers = useSelector(state => state?.cashiers?.Index ?? [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Cashiers" />
        </Container>
        <Table data={Cashiers} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Cashiers)
